import classNames from 'classnames';
import s from './IconButton.module.scss';
import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'> {
  children: ReactNode;
  size?: 'xs' | 's' | 'm' | 'l';
  color?: 'red' | 'black' | 'green' | 'yellow';
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, children, color, size = 'm', ...buttonProps }, ref) => (
    <button
      {...buttonProps}
      ref={ref}
      className={classNames(s.IconButton, color ? s[color] : undefined, s[size], className)}
    >
      {children}
    </button>
  ),
);

IconButton.displayName = 'IconButton';
